<template>
  <b-card>
    <contracts-table />
  </b-card>
  <!-- <app-collapse> -->

  <!-- <app-collapse-item
        v-for="object in GET_OBJECTS"
        :key="object.id"
        :data="object"
        :title="object.title"
        @export-excel="exportExcel"
      > -->
  <!-- v-if="object.id" -->
  <!-- :object-id="object.id" -->

  <!-- </app-collapse-item> -->

  <!-- </app-collapse> -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import contractsTable from './components/tables/contractsTable.vue'

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    contractsTable,
    BCard,
    BRow,
    BCol,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('objects', ['GET_OBJECTS']),
  },
  mounted() {
    this.FETCH_OBJECTS({ partial: true })
  },
  methods: {
    ...mapActions('objects', ['FETCH_OBJECTS']),

  },
}
</script>
